//Import Vue and Components
import {createApp, onMounted, onUnmounted, reactive, ref} from 'vue';
import { createPinia } from 'pinia';
import { useAuthStore} from '@stores/auth';

import MainMenuAuthComponent from '../Vue/Components/Frontend/Includes/menu/MainMenuAuthComponent.vue';
import MainMenuComponent from '../Vue/Components/Frontend/Includes/menu/MainMenuComponent.vue';

import MainLogo from '../Vue/Components/Frontend/Includes/MainLogo.vue';
import ButtonLargeComponent from '@buttons/ButtonLargeComponent.vue';
//Modal
import ModalMessageComponent from '../Vue/Components/Modals/ModalMessageComponent.vue';
import ModalEditComponent from '../Vue/Components/Modals/ModalEditComponent.vue';
//Auth
import MainLoginComponent from '../Vue/Components/Frontend/Auth/MainLoginComponent.vue';
import MainRegisterComponent from '../Vue/Components/Frontend/Auth/MainRegisterComponent.vue';
import MainForgotPasswordComponent from '../Vue/Components/Frontend/Auth/MainForgotPasswordComponent.vue';
import MainActivateAccountComponent from '../Vue/Components/Frontend/Auth/MainActivateAccountComponent.vue';
import MainVerifyAccountComponent from '../Vue/Components/Frontend/Auth/MainVerifyAccountComponent.vue';
import MainResetPasswordComponent from '../Vue/Components/Frontend/Auth/MainResetPasswordComponent.vue';
import ActivateEmailSentComponent from '../Vue/Components/Frontend/Auth/ActivateEmailSentComponent.vue';
import ResetPasswordSentComponent from '../Vue/Components/Frontend/Auth/ResetPasswordSentComponent.vue';
//Onboarding
import MainOnboardPasswordComponent from '../Vue/Components/Client/Onboard/MainOnboardPasswordComponent.vue';
import MainOnboardProfileComponent from '../Vue/Components/Client/Onboard/MainOnboardProfileComponent.vue';
import MainOnboardProfilePhotoComponent from '../Vue/Components/Client/Onboard/MainOnboardProfilePhotoComponent.vue';
import MainOnboardFinalStepComponent from '../Vue/Components/Client/Onboard/MainOnboardFinalStepComponent.vue';
//Contact
import MainContactComponent from '../Vue/Components/Frontend/Contact/MainContactComponent.vue';

//Courses
import FeaturedCourseMainComponent from '../Vue/Components/Frontend/Course/FeaturedCourseMainComponent.vue';

import MainFooterComponent from '../Vue/Components/Frontend/Includes/footer/MainFooterComponent.vue';
import Toast from 'vue3-toastify';
import axios from 'axios';
import 'vue3-toastify/dist/index.css';



//Create Vue Application
const app = createApp({
    // Add any global properties or methods
    data() {
        return {
            // Use the global variable

        };
    }
});

const modalMessageState = reactive({
    isVisible: false,
    component: null,
    callback: null,
    props: {},
    open(component, props = {}, callback = {} || null) {
        this.component = component;
        this.props = props;
        this.callback = callback;
        this.isVisible = true;
    },
    close() {
        this.isVisible = false;
        this.component = null;
        this.callback = null;
        this.props = {};
    }
});

const modalEditState = reactive({
    isVisible: false,
    component: null,
    callback: null,
    props: {},
    open(component, props = {}, callback = {} || null) {
        this.component = component;
        this.props = props;
        this.callback = callback;
        this.isVisible = true;
    },
    close() {
        this.isVisible = false;
        this.component = null;
        this.callback = null;
        this.props = {};
    }
});

app.use(Toast);
app.use(createPinia());

const authStore = useAuthStore();

authStore.loadToken();

// Restore user if available
if (!authStore.user && window.authUser) {
    authStore.user = window.authUser;
}

app.provide('axios', axios);

//Provide the modal state globally
app.provide('modalMessageState', modalMessageState);
app.provide('modalEditState', modalEditState);

//Register Components Globally
app.component('MainMenuComponent', MainMenuComponent);
app.component('MainMenuAuthComponent', MainMenuAuthComponent);

app.component('MainLogo', MainLogo);
app.component('ButtonLargeComponent', ButtonLargeComponent);

app.provide('ModalMessageComponent', ModalMessageComponent);
app.provide('ModalEditComponent', ModalEditComponent);

app.component('MainLoginComponent', MainLoginComponent);
app.component('MainRegisterComponent', MainRegisterComponent);
app.component('MainForgotPasswordComponent', MainForgotPasswordComponent);
app.component('MainActivateAccountComponent', MainActivateAccountComponent);
app.component('MainVerifyAccountComponent', MainVerifyAccountComponent);
app.component('MainResetPasswordComponent', MainResetPasswordComponent);
app.component('ActivateEmailSentComponent', ActivateEmailSentComponent);
app.component('ResetPasswordSentComponent', ResetPasswordSentComponent);

app.component('MainOnboardPasswordComponent', MainOnboardPasswordComponent);
app.component('MainOnboardProfileComponent', MainOnboardProfileComponent);
app.component('MainOnboardProfilePhotoComponent', MainOnboardProfilePhotoComponent);
app.component('MainOnboardFinalStepComponent', MainOnboardFinalStepComponent);

app.component('FeaturedCourseMainComponent', FeaturedCourseMainComponent);

app.component('MainContactComponent', MainContactComponent);

app.component('MainFooterComponent', MainFooterComponent);

//Mount the Vue Application
app.mount('#app');
